import { textStyleCss } from 'src/theme/atlas';
import styled from 'styled-components';

export const DownloadLink = styled.a`
  color: ${(props) => props.theme.atlas.semantic.color.action.primary.default};
  text-decoration: none;
  display: flex;
  align-items: center;
  font-size: 9px;
  font-weight: 400;
`;

export const DownloadText = styled.p<{ size: 'small' | 'large' }>`
  ${(props) =>
    props.size === 'small'
      ? `
  font-family: ${props.theme.atlas.typography.semantic.bodySmall.fontFamily};
  font-size: 9px;
  font-weight: 400;
  `
      : textStyleCss(props.theme.atlas.typography.semantic.bodySmall)};
  margin: 3px 0 3px 10px;
`;

export const DownloadIcon = styled.img<{ size: 'small' | 'large' }>`
  width: ${(props) => (props.size === 'small' ? 13 : 16)}px;
  height: ${(props) => (props.size === 'small' ? 13 : 16)}px;
`;
